module.exports = __webpack_public_path__ + "static/media/pen2.37fb51d3.jpg";